<template>
  <!-- App main wrapper -->
  <!-- Comment to test amplify auto-deploy-->
  <div class="mainContainer" :class="{ 'sidebar-is-collapsed': sidebarCollapsed }" style="display: flex; flex-direction: row;">
      <sidebar :collapsed="sidebarCollapsed" @toggle-collapse="sidebarCollapsed = !sidebarCollapsed" />
    <div class="content-container">
      <!-- DevWarning -->
      <dev-warning v-if="!isProd" />
      <!-- Route Header - Removido para integrar logout na sidebar -->
      <!-- App main content -->
      <main id="main" :class="{
        'main-padding': this.$route.meta.showSidebar
      }">
        <FadeTransition :duration="200" mode="out-in">
          <router-view :isProd="isProd" />
        </FadeTransition>
      </main>
      <div id="version">
        <p class="m-0">© {{ new Date().getFullYear() }} - Versão: {{ APPLICATION_VERSION }}</p>
      </div>
    </div>
    <ClienteQuickSearch :show="showQuickSearch" @close="showQuickSearch = false" @open="showQuickSearch = true" />
    <ClienteInicializarSistema :show="showInicializarSistema" @close="showInicializarSistema = false" />
    <ModalUsuarioLogado2FA v-if="modalUsuarioLogado" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { LOCALSTORAGE_KEY_LOGIN } from './lib/Authentication'
import { FadeTransition } from 'vue2-transitions';
import { getApiBaseUrl, isProdEnvironment } from './lib/apiBaseUrl'
import ModalUsuarioLogado2FA from './components/Autenticacao-2fa/Modals/UsuarioLogado.vue'
import ClienteQuickSearch from './components/quicksearch/ClienteQuickSearch.vue';
import ClienteInicializarSistema from './components/ClienteInicializarSistema.vue';

export default {
  name: 'App',
  components: {
    FadeTransition,
    ModalUsuarioLogado2FA,
    ClienteQuickSearch,
    ClienteInicializarSistema,
  },
  beforeMount() {
    // Forçando https em produção
    if (this.isProd && window.location.protocol !== 'https:') {
      window.location.href = window.location.href.replace('http', 'https');
      return;
    }
    // Iniciando dashboard
    const tokenJWT = localStorage.getItem('tokenJWT');

    this.token = tokenJWT || null;
    this.wsUrl = getApiBaseUrl();

    this.initDashboard();
    window.addEventListener('keydown', this.handleGlobalQuickSearch);

    // Ouve o evento global para colapsar/expandir sidebar
    this.$root.$on('toggle-collapse', this.toggleSidebarCollapse);
    this.$root.$on('toggle-expand', this.toggleSidebarExpand);
  },
  mounted() {
    // Listener para abrir o ClienteQuickSearch via sidebar
    this.$root.$on('open-quicksearch', () => {
      this.showQuickSearch = true;
    });
    this.$root.$on('open-inicializar-sistema', () => {
      this.showInicializarSistema = true;
    });
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleGlobalQuickSearch)
    this.$root.$off('open-quicksearch');
    this.$root.$off('open-inicializar-sistema');
    this.$root.$off('toggle-collapse', this.toggleSidebarCollapse)
    this.$root.$off('toggle-expand', this.toggleSidebarExpand)
  },
  computed: {
    ...mapGetters({
      modalUsuarioLogado: 'autenticacao2fa/getModalUsuarioLogado2FA',
    }),

    isProd() {
      return isProdEnvironment();
    }
  },
  data: () => ({
    APPLICATION_VERSION: APPLICATION_VERSION,
    token: null,
    wsUrl: null,
    showQuickSearch: false,
    showInicializarSistema: false,
    sidebarCollapsed: false
  }),
  methods: {
    ...mapActions({
      setAuthentication: 'autenticacao/setAuthentication',
      fetchAmplifyBranches: 'amplifyBranches/fetchAmplifyBranches'
    }),
    async initDashboard() {
      this.setAuthentication({
        token: this.token,
        baseUrl: this.wsUrl
      })
      
      // Aguardar Vue processar a autenticação antes de fazer chamadas
      await this.$nextTick()
      
      // Buscar branches do Amplify ao iniciar o dashboard
      console.log('[APP] Iniciando busca de branches do Amplify...')
      try {
        await this.fetchAmplifyBranches()
        console.log('[APP] Branches do Amplify carregadas com sucesso')
      } catch (error) {
        console.error('[APP] Erro ao carregar branches do Amplify:', error)
      }
    },
    handleGlobalQuickSearch(e) {
      if ((e.ctrlKey && e.key === 'p') && !this.showQuickSearch) {
        e.preventDefault();
        this.showQuickSearch = true;
      }
      if (e.key === 'Escape' && this.showQuickSearch) {
        this.showQuickSearch = false;
      }
    },
    toggleSidebarCollapse() {
      this.sidebarCollapsed = true;
    },
    toggleSidebarExpand() {
      this.sidebarCollapsed = false;
    }
  }
};
</script>

<style lang="scss">
@use "./assets/styles/main";
</style>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');
</style>